/* Considered · where the catalogue lives: the Gift selector Supabase project.
   Public read, writes closed to clients (RLS). Used by data.js in the browser
   and by scripts/prerender-considered.mjs at build time. */
export const CATALOGUE_URL = 'https://iunongmzazswbonqhwav.supabase.co';
export const CATALOGUE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml1bm9uZ216YXpzd2JvbnFod2F2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAyNDc0NDQsImV4cCI6MjA5NTgyMzQ0NH0.ZveyRwxC7INDIaXmxvNRO_RZnRUBqPVRph9VbZu64Qo';   // anon key — public by design

/* "Spirits & wine" -> "spirits-wine". The app's category URLs use this. */
export function catSlug(name) {
  return (name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

/* Our own copy of a brand's logo or a pick's photo, in the catalogue's public bucket. */
export function fileUrl(path) {
  return path ? CATALOGUE_URL + '/storage/v1/object/public/catalogue/' + path : null;
}
